var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteTrackTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "currentColor",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.092 16.2-3.237-2.682c-.892-.744-.392-2.138.725-2.224h.002l4.23-.31a.082.082 0 0 0 .066-.04l.002-.005 1.766-4.207h.084c.59-.653 1.751-.53 2.127.368l1.614 3.844c.005.012.025.036.066.039l4.232.311c1.117.086 1.616 1.48.725 2.224h-.002l-3.242 2.693a.034.034 0 0 0-.011.017.061.061 0 0 0 0 .033l1.008 4.032c.28 1.13-.966 1.948-1.908 1.38l-3.615-2.178-.004-.002a.086.086 0 0 0-.085 0l-.003.002-3.616 2.177c-.941.569-2.187-.25-1.908-1.379v-.002l1.01-4.03a.044.044 0 0 0-.002-.026.09.09 0 0 0-.024-.035Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M44.637 9.998a4.97 4.97 0 0 1 4.963 4.97v30.6a4.97 4.97 0 0 1-4.963 4.97H14.1a4.97 4.97 0 0 1-4.963-4.97V23.653l3.146-1.945.963.598v23.26a.86.86 0 0 0 .854.857h30.537a.86.86 0 0 0 .855-.857V14.97a.86.86 0 0 0-.855-.857H22.268l.344-.83a2.998 2.998 0 0 0-.064-2.405l-.462-.88h22.551Zm-21.332 1.2Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.234 29.39c.755.405.755 1.569 0 1.973l-3.967 2.125c-.675.362-1.467-.17-1.467-.986v-4.25c0-.816.791-1.348 1.467-.986l3.967 2.125Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M37.2 30.42a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-2 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteTrackTitle);
export default __webpack_public_path__ + "static/media/favorite-track-title.d5dd35fd.svg";
export { ForwardRef as ReactComponent };